import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FaEye } from 'react-icons/fa6'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { KTSVG } from '../../../_metronic/helpers'
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp'
import DateComp from '../../../components/dateComponent/DateComp'
import DateTimeComp from '../../../components/dateComponent/DateTimeComp'
import { constraintConfig } from '../../../constraintConfig'
import { selectAuth } from '../../../features/authSlice'
import { useAppSelector } from '../../../hooks'
import labelKey from "../../localization/label.json"
import ConfirmationExpenseModal from './ConfirmationExpenseModal'
import ExpenseLogModal from './ExpenseLogModal'
import { Tooltip } from 'react-tooltip'
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent'
import ExpenseStatusComp from '../../../components/StatusComp/ExpenseStatusComp'

type Props = {
  show: boolean
  handleClose: () => void
  data: any
  expenseItems?: any
  isFetching?: any
  refetch?: any
  itsApprover?: any
}
interface LightboxData {
  imageURL: string;
}
const ExpenseDetailModal = ({ show, handleClose, data, expenseItems, isFetching, refetch, itsApprover }: Props) => {

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
  const { roleID, userAccountID } = useAppSelector(selectAuth);
  const [showExpenseConfirmationModal, setShowExpenseConfirmationModal] = useState(false)
  const [expenseConfirmationData, setExpenseConfirmationData] = useState({});


  const isPdfFile = (filePath: string | undefined) => {
    if (!filePath) return false;
    const fileExtension = filePath.toLowerCase().split('.').pop();
    return fileExtension === 'pdf';
  };
  const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
    if (attachmentFile) {
      if (isPdfFile(attachmentFile)) {
        // For PDF files, open in the browser
        window.open(attachmentFile, '_blank');
      } else {
        // For image files, open in the Lightbox
        setLightboxData({ imageURL: attachmentFile });
        setLightboxOpen(true);
      }
    }
  };


  const expenseConfirmationModalHandler = () => {
    setShowExpenseConfirmationModal((prev) => !prev);
  };
  const handleCloseModals = () => {
    setShowExpenseConfirmationModal(false);
    handleClose(); // Close the parent modal
  };
  const [showExpenseLogModal, setShowExpenseLogModal] = useState(false)
  const [expenseLogData, setExpenseLogData] = useState({});
  const expenseLogHandler = () => {
    setShowExpenseLogModal((prev) => !prev);
  };

  return (
    <>
      <ConfirmationExpenseModal show={showExpenseConfirmationModal}
        handleClose={() => setShowExpenseConfirmationModal(false)}
        data={expenseConfirmationData}
        handleCloseModals={handleCloseModals}
        refetch={refetch} />
      <ExpenseLogModal show={showExpenseLogModal}
        handleClose={() => setShowExpenseLogModal(false)}
        data={expenseLogData} />

      <Modal
        aria-hidden='true'
        fullscreen
        backdrop='static'
        dialogClassName='modal-dialog modal-fullscreen ss-expense-detail-dialog'
        contentClassName='ss-expense-detail-modal'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header flex-shrink-0'>
          <h2 className='mb-0'>{labelKey.expenseDetails} - ({data?.title})</h2>
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body d-flex flex-column flex-grow-1 overflow-hidden p-4 p-md-6'>
          <div className='flex-shrink-0 mb-4 ss-expense-detail-overview'>
          <div className="row g-4 align-items-start">
            <div className="col-12 col-md-6 col-lg-4">
              {(roleID === constraintConfig.roleID.role1 || roleID === constraintConfig.roleID.role2) && (
                <div className='d-flex align-items-center mb-3'>
                  <div className='symbol symbol-50px me-4'>
                    <div className="symbol-label fs-3 bg-light-info text-info text-capitalize"
                    >
                      {data?.userAccount?.firstName.charAt(0)}
                    </div>

                  </div>
                  <div className='d-flex justify-content-start flex-column'>
                    <p className='text-dark fw-bold mb-0 fs-6 text-capitalize'>
                      {data?.userAccount?.firstName} {data?.userAccount?.lastName}
                    </p>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                      {data?.userAccount?.email}
                    </span>
                  </div>
                </div>
              )}
              <div>
                <p className='fw-bold mb-1'>{labelKey.reportId}: <span className='fw-semibold'>{data?.trackingId}</span></p>
                <p className='fw-bold mb-0'>{labelKey.totalAmount}: <span className='fw-semibold'>
                  <CurrencyComp amount={data?.amount} /></span></p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <p className='fw-bold mb-1'>{labelKey.month}: <span className='fw-semibold'>
                <DateComp formattedDate={data?.reportDate} /></span></p>
              <p className='fw-bold mb-0'>{labelKey.status}: &nbsp;
                {!itsApprover ? <>
                  <ExpenseStatusComp expenseStatusId={data?.expenseStatus?.id} expenseStatusTitle={data?.expenseStatus?.title} />
                </> :
                  <>
                    {data?.approverStatus?.id === constraintConfig.approverStatus.pending ?
                      <span className="badge badge-light-primary fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                      data?.approverStatus?.id === constraintConfig.approverStatus.approved ?
                        <span className="badge badge-light-success fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                        data?.approverStatus?.id === constraintConfig.approverStatus.rejected ?
                          <span className="badge badge-light-danger fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                          // data?.approverStatus?.id === "Clarification" ?
                          //     <span className="badge badge-light-warning fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                          data?.approverStatus?.id === constraintConfig.approverStatus.accountsPayable ?
                            <span className="badge badge-light-success fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                            <span className="badge badge-light-primary fs-7 fw-semibold">{data?.approverStatus?.title}</span>
                    }
                  </>
                }
              </p>

            </div>

            <div className="col-12 col-lg-5">
              <p className='fw-bold mb-0'>{labelKey.reportTitle}:</p>
              <p className='mb-2 text-muted'>{data?.title || 'N/A'}</p>
              <p className='fw-bold mb-0'>{labelKey.description}:</p>
              <p className='mh-80px overflow-auto text-muted mb-0'>{data?.expenseDetail || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className='table-responsive table-height flex-grow-1 overflow-auto border rounded'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-0'>
                <thead>
                  <tr>
                    <th className='ps-4 rounded-start w-100px'>{labelKey.itemDate}	</th>
                    <th>{labelKey.expenseType}</th>
                    <th>{labelKey.category}</th>
                    <th>{labelKey.currency}</th>
                    <th className='text-end'>{labelKey.amount}</th>
                    <th className='w-150px text-end'>{labelKey.distance}</th>
                    <th className='w-150px text-end'>{labelKey.reimbursableDistance}</th>
                    <th>{labelKey.startLocation}</th>
                    <th>{labelKey.endLocation}</th>
                    <th>{labelKey.vendor}</th>
                    <th>{labelKey.paymentMethod}</th>
                    <th>{labelKey.chargeLocation}</th>
                    <th className='w-100px'>{labelKey.attachment}</th>
                    <th className='ss-source-col'>{labelKey.source}</th>
                    <th className='w-150px'>{labelKey.createdOn}</th>
                    <th className='w-150px'>{labelKey.modifiedOn}</th>
                    <th className='w-200px rounded-end'>{labelKey.description}</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching ?
                    <tr>
                      <td colSpan={22}>
                        <LoadingComponent />
                      </td>
                    </tr>
                    :
                    <>
                      {expenseItems?.map((itemData: any, index: any) => (
                        <>
                          <tr key={index}>
                            <td><DateComp formattedDate={itemData.itemDate} /></td>
                            <td>{itemData?.expenseType?.title}</td>
                            <td className='ps-5'>{itemData?.expenseCategory?.title}</td>
                            <td>{itemData?.currency?.title}</td>
                            <td className='text-end'> <CurrencyComp amount={itemData?.amount} /></td>
                            <td className='text-end'>
                              {itemData?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                <>
                                  {itemData?.milage}
                                </>
                                : null
                              }
                            </td>
                            <td className='text-end'>
                              {itemData?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                <>
                                  {itemData?.reimbursableDistance}
                                </>
                                : null
                              }
                            </td>
                            <td>
                              {itemData?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                <>
                                  {itemData?.startLocation}
                                </>
                                : null
                              }
                            </td>
                            <td>
                              {itemData?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                <>
                                  {itemData?.endLocation}
                                </>
                                : null
                              }
                            </td>
                            <td>{itemData?.vendor?.name !== " " ? itemData?.vendor?.name : "N/A"}</td>
                            <td>{itemData?.paymentMethod?.title}</td>
                            <td>{itemData?.expItemLocation?.title ? itemData?.expItemLocation?.title : <span>N/A</span>}</td>
                            <td className="text-center">
                              <div className="d-flex flex-column align-items-center gap-1">
                                {itemData?.attachmentFile === "undefined" ||
                                  itemData?.attachmentFile === "" ||
                                  itemData?.attachmentFile === "null" ||
                                  itemData?.attachmentFile === null ||
                                  itemData?.attachmentFile === "Receipt is not available" ?
                                  <span>N/A</span> :
                                  <FaEye className="cursor-pointer" onClick={() => openPdfInBrowserOrLightbox(itemData?.attachmentFile)} />
                                }
                                {itemData?.receiptUploadedDateTime ? (
                                  <span
                                    className="text-muted fs-8"
                                    title={labelKey.receiptUploadedDateTime}
                                    data-tooltip-id="receipt-uploaded"
                                    data-tooltip-content={`${labelKey.receiptUploadedDateTime}: compare with Created On to see if receipt came from Receipt Vault or was attached later`}
                                  >
                                    <DateTimeComp formattedDate={itemData.receiptUploadedDateTime} />
                                  </span>
                                ) : (
                                  itemData?.attachmentFile &&
                                  itemData?.attachmentFile !== "undefined" &&
                                  itemData?.attachmentFile !== "" &&
                                  itemData?.attachmentFile !== "null" &&
                                  itemData?.attachmentFile !== "Receipt is not available" ? (
                                    <span className="text-muted fs-8">—</span>
                                  ) : null
                                )}
                              </div>
                              {lightboxOpen && (
                                <Lightbox
                                  mainSrc={lightboxData.imageURL}
                                  onCloseRequest={() => setLightboxOpen(false)}
                                  imageCaption="Attachment"
                                  enableZoom={true}
                                  imagePadding={50}
                                />
                              )}
                            </td>
                            <td className='ss-source-col'>
                              <Tooltip id="web-source" place="top" />
                              <Tooltip id="mobile-source" place="top" />
                              <Tooltip id="bank-source" place="top" />
                              <Tooltip id="gorilla-source" place="top" />
                              <Tooltip id="receipt-uploaded" place="top" />

                              {itemData?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4 ss-source-icon'
                                  svgClassName='w-20px h-20px'
                                  data-tooltip-id="web-source" data-tooltip-content='Website' />
                                :
                                itemData?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                  <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4 ss-source-icon'
                                    data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                  itemData?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                    <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4 ss-source-icon'
                                      data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                    : itemData?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                      <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                        data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                            </td>
                            <td><DateTimeComp formattedDate={itemData?.createdDate} /></td>
                            <td><DateTimeComp formattedDate={itemData?.updatedDate} /></td>
                            <td>
                              <div className='overflow-auto text-wrap'>
                                {itemData?.itemDetail}
                              </div>
                            </td>
                          </tr>
                          {itemData.splitLineItems && itemData.splitLineItems.map((splitItem: any, splitIndex: any) => (
                            <>

                              {splitIndex === 0 && splitItem.amount > 0 && (
                                <tr className="p-2">
                                  <td></td>
                                  <td></td>
                                  <td className="text-start fw-bold bg-light" colSpan={2}>{labelKey.splitLocations} ( {itemData.splitLineItems.length} )</td>
                                  <td className="text-end fw-bold bg-light pe-5">{labelKey.splitAmount} </td>
                                  {/* <td className="text-start fw-bold bg-light" colSpan={11}></td> */}
                                </tr>
                              )}
                              {splitItem.amount > 0 &&
                                <tr key={`${index}-${splitIndex}`} className="split-item-row">
                                  <td></td>
                                  <td></td>
                                  <td className="text-start bg-light" colSpan={2}>
                                    {splitItem.expItemLocation?.title ? splitItem.expItemLocation.title : <span>N/A</span>}
                                  </td>
                                  <td className="text-end bg-light pe-5">
                                    <CurrencyComp amount={splitItem.amount} />
                                  </td>
                                  {/* <td className="text-end bg-light" colSpan={11}></td> */}
                                </tr>
                              }
                            </>
                          ))}
                          {itemData.isSplitCategory && itemData.splitCategory && itemData.splitCategory.map((splitItem: any, splitIndex: any) => (
                            <>

                              {splitIndex === 0 && splitItem.amount > 0 && (
                                <tr className="p-2">
                                  <td></td>
                                  <td></td>
                                  <td className="text-start fw-bold bg-light" colSpan={2}>{labelKey.splitCategory} ( {itemData.splitCategory.length} )</td>
                                  <td className="text-end fw-bold bg-light pe-5">{labelKey.splitAmount} </td>
                                  {/* <td className="text-start fw-bold bg-light" colSpan={11}></td> */}
                                </tr>
                              )}
                              {splitItem.amount > 0 &&
                                <tr key={`${index}-${splitIndex}`} className="split-item-row">
                                  <td></td>
                                  <td></td>
                                  <td className="text-start bg-light" colSpan={2}>
                                    {splitItem.expItemCategory?.title ? splitItem.expItemCategory.title : <span>N/A</span>}
                                  </td>
                                  <td className="text-end bg-light pe-5">
                                    <CurrencyComp amount={splitItem.amount} />
                                  </td>
                                  {/* <td className="text-end bg-light" colSpan={11}></td> */}
                                </tr>
                              }
                            </>
                          ))}
                        </>

                      ))}
                    </>
                  }
                </tbody>
              </table>
            </div>
        </div>
        <div className='modal-footer flex-shrink-0'>
          <button className='btn btn-light-danger' onClick={handleClose}>{labelKey.close}</button>
          {(data?.expenseStatus?.id !== constraintConfig.expenseStatus.drafted &&
            <button className='btn btn-light-primary'
              onClick={() => {
                setExpenseLogData(data);
                expenseLogHandler();
              }}>{labelKey.expenseLogs}</button>
          )}
          {data?.userAccount?.orgUserID === userAccountID && <>
            {(data?.expenseStatus?.id === constraintConfig.expenseStatus.drafted ||
              data?.expenseStatus?.id === constraintConfig.expenseStatus.rejected)
              && (
                <button className='btn  btn-primary'
                  onClick={() => {
                    setExpenseConfirmationData(data);
                    expenseConfirmationModalHandler();
                  }}
                >{labelKey.submitForApproval}</button>
              )}
          </>}
        </div>
      </Modal >
    </>
  )
}

export default ExpenseDetailModal